import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from './../environments/environment';

@Component({
  selector: 'flex-privacy-policy-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly translateService = inject(TranslateService);

  constructor() {
    const defaults = environment.defaults;
    // const locale = localStorage.getItem('locale') || defaults.locale || 'en-us';
    const locale = 'en-ie';
    const brand = localStorage.getItem('brand') || defaults.brand || 'enelx';

    const langTag = `${locale}.${brand.toUpperCase()}`;

    this.translateService.setFallbackLang(langTag);
    this.translateService.use(langTag);
  }
}
